import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Visualize3dObjectChangeEvent } from '../models/events/visualize3d-object-change-event';
import { Visualize3dObject } from '../models/visualize3d-object';
import { Visualize3dObjectSelectionChangeEvent } from '../models/events/visualize3d-object-selection-change-event';

@Injectable({
  providedIn: 'root',
})
export class Visualize3dObjectEventService implements OnDestroy {
  public v3dObjectChanged = new Subject<Visualize3dObjectChangeEvent>();
  public v3dObjectSelectionChanged = new Subject<Visualize3dObjectSelectionChangeEvent>();

  public ngOnDestroy(): void {
    this.v3dObjectChanged.unsubscribe();
    this.v3dObjectSelectionChanged.unsubscribe();
  }

  public updateSelectedObject(v3dObject: Visualize3dObject | undefined): void {
    this.v3dObjectSelectionChanged.next({
      v3dObject,
    });
  }
}
